// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HUVfW{overflow-y:auto;height:100%}.HUVfW .IPGdM{display:flex;flex-direction:column;gap:24px;overflow-y:auto;justify-content:center}.HUVfW .IPGdM .mUSGY{display:flex;flex-direction:row;justify-content:space-between;align-items:center;gap:10px;background-color:#fff;padding:30px 24px}.HUVfW .IPGdM .mUSGY .oJsRz{font-size:16px;font-weight:600}.HUVfW .IPGdM .mUSGY .RIsmM{width:180px}.HUVfW .H3A84{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;margin-top:10px}.HUVfW .H3A84 .Npqz2{margin-top:16px;width:140px;height:35px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"connectedAppsWrapper": `HUVfW`,
	"integrationsContainer": `IPGdM`,
	"integration": `mUSGY`,
	"integrationHeader": `oJsRz`,
	"manageButton": `RIsmM`,
	"emptyStateWrapper": `H3A84`,
	"exploreAppsButton": `Npqz2`
};
export default ___CSS_LOADER_EXPORT___;
